import { caching } from '@/common/cache.dict.js';
import { tagKinds } from '@/common/page_comp/Tag/util.js';
import { boundApiRequest } from '@/restapi/restapi.base.js';


const doRequest = boundApiRequest('/api/tag/');


export async function searchTags(reqt) {
    const { result } = await doRequest('search', reqt);
    return result;
}

export async function searchWithKindGroup(query, kind = null) {
    const tags = await searchInput(query, kind);
    const result = [];

    for (const kind of tagKinds) {
        const tagsByKind = tags.filter(t => t.kind === kind.id);

        if (!tagsByKind.length)
            continue;

        result.push({
            id: 'k_' + kind.id,
            name: kind.name,
            options: tagsByKind,
        });
    }
    return result;
}

export async function searchInput(query = '', kind = null) {
    const { result } = await doRequest('input/search', {
        query,
        kind,
        limit: 300,
    });
    return result;
}

export async function loadInput(id) {
    const { result } = await doRequest('input/load', { id });
    return result;
}

export async function exists(reqt) {
    const { result } = await doRequest('exists', reqt);
    return result;
}

export async function removeTag(id) {
    const { result } = await doRequest('remove', { id });
    return result;
}

export async function saveTag(reqt) {
    const { result } = await doRequest('save', reqt, { blocking: true });
    return result;
}

export async function loadTag(id) {
    const { result } = await doRequest('load', { id });
    return result;
}

async function _loadAllTags() {
    const { result } = await doRequest('input/search', {
        query: '',
        kind: null,
        limit: 99999999,
    });
    return result;
}

export const allTags = caching(_loadAllTags);
